import React from 'react'
import styles from "../css/Notes.module.css"
const NoNotes = () => {
  return (
    <div data-testid = "no-notes-yet" className = {styles.emptyContainer}>
        <img
          src = "/assets/notepad.png"
          alt = "Empty Board"
          loading="lazy"
        />
        <div className = {styles.eyebrow}>No Notes Yet</div>
        <div className = {styles.title}>Your notes board is <span>empty</span></div>
        <div className = {styles.desc}>Start capturing your ideas, tasks, and thoughts.<br/>Your first note is just a click away.</div>
    </div>
  )
}

export default NoNotes